// Profile helper functions and data
import { BaseOrder } from "@sushicorp/types";
import dayjs from "dayjs";

import { AllocationOptions } from "./Profile.types";

/**
 * Helper to get formatted order date.
 *
 * @param {BaseOrder} order Order data.
 * @param {Record<string, any>} t Words data.
 * @returns Formatted order data.
 */
export const orderDateSelectedByAllocationHelper = (
  order?: BaseOrder,
  t?: Record<string, any>
) => {
  if (!order) return;
  const { orderDate, allocation, orderTime } = order;
  const allocationOptionsByOrderDate: AllocationOptions = {
    DELIVERY: orderDate,
    PICKUP_IN_PLACE: orderDate,
    PICKUP_TO_GO: orderDate
  };
  const allocationOptionsByOrderTime: AllocationOptions = {
    DELIVERY: orderTime,
    PICKUP_IN_PLACE: orderTime,
    PICKUP_TO_GO: orderTime
  };
  const orderDateSelected = allocationOptionsByOrderDate[allocation];
  const orderTimeSelectedFormat = allocationOptionsByOrderTime[allocation];
  const orderDateSelectedFormat = dayjs(orderDateSelected).format("DD/MM/YYYY");
  const isToday = dayjs().isSame(dayjs(orderDateSelected), "day");

  const dayFormat = isToday ? t?.order.today : orderDateSelectedFormat;

  return orderDateSelectedFormat && orderTimeSelectedFormat
    ? `${dayFormat}`
    : "";
};

export const getOrderDateFormat = () => {};
